import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Offer, Quote, QuoteState } from '@app/quoting/models/quote';
import { QuoteSettingsService } from '@app/quoting/services/quote-settings.service';
import { QuoteService } from '@app/quoting/services/quote.service';
import { quoteSelector } from '@app/state/app.selectors';
import { AppState } from '@app/state/app.state';
import { Store } from '@ngrx/store';
import { filteredPricesSelector } from '@utility-information/state/selectors/utility-information.selectors';
import { Subscription } from 'rxjs';
import { SetContractLengthsSelected } from '@utility-information/state/actions/utility-information.actions';

@Component({
  selector: 'app-quote-results',
  templateUrl: './quote-results.component.html',
  styleUrls: ['./quote-results.component.scss'],
})
export class QuoteResultsComponent implements OnInit, OnDestroy {
  public quote: Quote;
  public fetching: boolean;


  @Output() offersActioned = new EventEmitter();
  @Input() allMarginChanged;
  filteredPrices: Offer[];
  quoteRequestId: number;
  route$: Subscription;
  selectQuote$: Subscription;
  maxPlanTypeLength: number;
  filteredPrices$: any;
  defaultContractLengths: any;
  isAllMarginChanged: boolean;

  constructor(
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private quoteService: QuoteService,
    public settingsService: QuoteSettingsService
  ) {
    this.route$ = this.route.params.subscribe((x) => {
      if (!isNaN(x.quoteRequestId)) {
        this.quoteRequestId = Number(x.quoteRequestId);
      }
      this.filteredPrices$ = this.store.select(filteredPricesSelector);
    });
  }

  ngOnDestroy(): void {
    this.route$?.unsubscribe();
    this.selectQuote$?.unsubscribe();
    this.store.dispatch(new SetContractLengthsSelected(this.quoteRequestId.toString(), undefined));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.allMarginChanged) this.isAllMarginChanged = changes?.allMarginChanged.currentValue;
  }

  ngOnInit(): void {
    this.selectQuote$ = this.store.select(quoteSelector).subscribe((s) => {
      if (s.quote && s.quote.quoteRequestState?.quoteRequestId === this.quoteRequestId) {
        const quote = s.quote;

        // We only need to render the approved prices.
        if (
          quote.quoteState === QuoteState.REQUEST_APPROVED ||
          quote.quoteState === QuoteState.OFFER_ACCEPTED ||
          quote.quoteState === QuoteState.OFFER_REJECTED
        ) {
          // In our server method when price collection is summed per term
          // any price term not found in that collection will have an instantiated
          // instance with NoResult set to true.
          // We don't want these if its a quote request that has been approved, only want to render
          // approved offers and not have "no result found" UI elements.
          quote.prices = quote.prices.filter((p) => !p.noResult);
        }

        this.quote = quote;
        this.quoteService.loadFactorUpdated.emit(quote);
        this.quoteService.pricingCurveDate.emit(quote);
        this.fetching = s.fetching;
        this.filteredPrices$.subscribe((prices) => {
          this.filteredPrices = prices;          
          for (var i = 0; i < this.filteredPrices?.length; i++) {
            if (this.filteredPrices[i].planType != null) {
              if (this.filteredPrices[i].planType.length > this.maxPlanTypeLength)
                this.maxPlanTypeLength = this.filteredPrices[i].planType.length;
            }
          }
        });
      }
    });

    this.quoteService.quoteUpdated.subscribe((quote) => {
      this.quote = quote;
    });
  }

  public onOfferActioned($event) {
    this.offersActioned.emit($event);
  }
}
